import React, { useState, useEffect } from 'react'
import { useParams } from 'react-router-dom'

const LegalPage = () => {
  const { type } = useParams()
  const [content, setContent] = useState('')
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    const loadContent = async () => {
      try {
        let fileName = ''
        let title = ''
        
        switch (type) {
          case 'impressum':
            fileName = '/src/templates/Impressum.html'
            title = 'Impressum/Datenschutz'
            break
          default:
            fileName = '/src/templates/Impressum.html'
            title = 'Impressum/Datenschutz'
        }

        // Importiere den HTML-Content direkt als String
        // Da fetch() nicht mit src-Dateien funktioniert, verwenden wir einen direkten Import
        const htmlContent = await import(`../templates/${type === 'impressum' ? 'Impressum' : 'Impressum'}.html?raw`)
        
        // Nur den Inhalt zwischen <body> Tags extrahieren
        const bodyMatch = htmlContent.default.match(/<body[^>]*>([\s\S]*?)<\/body>/i)
        if (bodyMatch) {
          setContent(bodyMatch[1])
        } else {
          // Fallback: ganzen Content verwenden wenn <body> Tags nicht gefunden werden
          setContent(htmlContent.default)
        }
      } catch (error) {
        console.error('Error loading content:', error)
        setContent('<p>Fehler beim Laden des Inhalts.</p>')
      } finally {
        setLoading(false)
      }
    }

    loadContent()
  }, [type])

  if (loading) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100 dark:from-dark-900 dark:to-dark-800 flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary-600 mx-auto mb-4"></div>
          <p className="text-gray-600 dark:text-gray-400">Lade Inhalt...</p>
        </div>
      </div>
    )
  }

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100 dark:from-dark-900 dark:to-dark-800 transition-colors duration-300">
      <div className="container mx-auto px-4 py-12">
        <div className="max-w-4xl mx-auto">
          <div className="bg-white dark:bg-dark-800 shadow-lg rounded-xl border border-gray-200 dark:border-dark-700 p-8">
            <div 
              className="prose prose-lg max-w-none dark:prose-invert"
              dangerouslySetInnerHTML={{ __html: content }}
            />
          </div>
        </div>
      </div>
    </div>
  )
}

export default LegalPage
